import { createReducer } from 'typesafe-actions';
import { purge } from '../auth/actions';
import {
  claimPayment,
  getContract,
  getUpdateDebts,
  setContractInformations,
  setSelectedInstallments,
  setSelectedPaymentMethod,
} from './actions';

const INITIAL_STATE: ContractState = {
  list: [],
  error: '',
  contractsLoading: true,
  requestOk: false,
  contractInformations: null,
  selectedInstallments: [],
  selectedPaymentMethod: null,
};

const contactsReducer = createReducer(INITIAL_STATE)
  .handleAction(purge, () => INITIAL_STATE)
  .handleAction(getContract.success, (state, action) => ({
    ...state,
    list: action.payload,
    contractsLoading: false,
  }))
  .handleAction(getContract.request, (state, action) => ({
    ...state,
    contractsLoading: true,
  }))
  .handleAction(getContract.failure, (state, action) => ({
    ...state,
    error: action.payload,
    contractsLoading: false,
  }))
  .handleAction(claimPayment.failure, (state, action) => ({
    ...state,
    requestOk: false,
  }))
  .handleAction(claimPayment.success, (state, action) => ({
    ...state,
    requestOk: action.payload === 'ok',
  }))
  .handleAction(setContractInformations, (state, action) => ({
    ...state,
    contractInformations: action.payload,
  }))
  .handleAction(setSelectedInstallments, (state, action) => ({
    ...state,
    selectedInstallments: action.payload,
  }))
  .handleAction(setSelectedPaymentMethod, (state, action) => ({
    ...state,
    selectedPaymentMethod: action.payload,
  }))
  .handleAction(getUpdateDebts.request, (state, action) => ({
    ...state,
    contractsLoading: true,
  }));
export default contactsReducer;
